import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { HomeService } from 'src/app/shared/services/home.service';
import {ReportService} from '../service/report.service';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { SidePanelService } from 'src/app/shared/services/side-pannel/side-pannel.service';

@Component({
  selector: 'app-repository',
  templateUrl: './repository.component.html',
  styleUrls: ['./repository.component.scss']
})
export class RepositoryComponent implements OnInit, OnDestroy {
  // public dataSource: any;
  public scrollDistance = 1;
  public throttle = 10;
  public page = 1;
  public displayedColumns = ['Sl No.', 'Study Title', 'Description', 'Type', 'Project','Completion Date', 'Uploaded By', 'Details'];
  public accessRoles:any;
  constructor(private homeService:HomeService, 
    public reportService:ReportService,
    private sidepannel:SidePanelService,
    public dialog: MatDialog, 
    public router:Router) {
    this.homeService.sidenav2Open.next(false); 
    this.homeService.hardCodeRepo = !this.router.url.includes('repository-report');
    this.reportService.crossTableReset();
    this.sidepannel.switchGlobalSearch(false);
  }

  ngOnInit() {
    this.getUploadData();
    this.reportService.isRepoDetailsSearch = false;
    this.reportService.isRepoSearch = true;
    this.reportService.searchText = '';
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
  }
   
  ngOnDestroy(){
    this.reportService.httpPostOptions.params = {};
    this.reportService.dataSource = [];
    this.reportService.isUpload = false;
  }

  getUploadData(){
    this.reportService.getRepos();
  }

  selectRepository(repo){
    this.reportService.reportDetails = repo;
    this.router.navigate(['/repo/details/'+repo.uuid]);
    // this.router.navigate(['/home/repository-report/details/'+repo.uuid]);
    // this.reportService.checkSignTestUserLevelAccess();
  }
  
  

  openDialog(){
    this.dialog.open(DialogDataDialog, {
      width: '575px'      
    });
  }

  onScroll(){
    if (this.reportService.totalReportsPage > this.page) {
      this.page++;
      this.reportService.getRepos({"page":this.page});
    }
  }


}

@Component({
  selector: 'dialog-form',
  templateUrl:'./dialog-form.html',
  styleUrls: ['./repository.component.scss']
})

export class DialogDataDialog implements OnInit {
  public form: FormGroup | undefined;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder) {}

  ngOnInit(): void {
      this.form = this.formBuilder.group({
        name : ['']
    });

   
  }
  upload(event: Event) {
    const target = event.target as HTMLInputElement;
    const files = target.files as FileList;
  }
}
